import { render, staticRenderFns } from "./CronogramaFisicoForm.vue?vue&type=template&id=aed95640"
import script from "./CronogramaFisicoForm.vue?vue&type=script&lang=js"
export * from "./CronogramaFisicoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports